import React from 'react';
import PropTypes from 'prop-types';
import Graph from 'react-graph-vis';

const useGraphOptions = () => {
  const options = React.useMemo(
    () => ({
      layout: { randomSeed: 2 },

      nodes: {
        borderWidth: 1,
        size: 20,
        // color: {
        //   // border: "#222222",
        //   // background: "#666666"
        // },
        font: { color: '#666666' },
      },
      edges: {
        length: 150,
        width: 2,
        font: { align: 'bottom', strokeWidth: 3, strokeColor: '#ffffff' },
        color: {
          color: '#cccccc',
          highlight: '#aabbee',
          hover: '#aaaaaa',
          inherit: 'both',
          opacity: 1,
        },
        arrowStrikethrough: false,
        // font: '12px arial #ff0000',
        scaling: {
          label: true,
        },
        // smooth: {
        //   type: 'continuous',
        //   forceDirection: 'horizontal',
        // },
      },
      groups: {
        main: {
          color: '#F03967',
          borderWidth: 0,
          shape: 'box',
          font: { color: '#FFFFFF' },
          margin: { top: 15, right: 20, bottom: 15, left: 20 },
          widthConstraint: 100,
        },
        category: {
          color: '#72c782',
          borderWidth: 0,
          shape: 'box',
          margin: { top: 10, right: 15, bottom: 10, left: 15 },
          font: { color: '#FFFFFF' },
          widthConstraint: 100,
        },
        channel: {
          color: '#6699ff',
          borderWidth: 0,
          font: { color: '#FFFFFF' },
          // shape: "icon",
          // icon: {
          //   face: "FontAwesome",
          //   code: "\uf0c0",
          //   size: 50,
          //   color: "#6699ff"
          // }
        },
      },
      interaction: {
        hover: true,
        dragNodes: false,
      },
      physics: {
        enabled: true,
        solver: 'repulsion',
        repulsion: {
          nodeDistance: 150, // Put more distance between the nodes.
        },
      },
    }),
    []
  );
  return options;
};

function NetworkGraph({ onClick }) {
  const [graph] = React.useState({
    nodes: [
      {
        id: 1,
        group: 'main',
        label: 'Payment Gateway',
        title: 'node 1 tootip text',
      },
      { id: 2, group: 'category', label: 'Banks', title: 'node 2 tootip text' },
      {
        id: 3,
        group: 'category',
        label: 'eWallet',
        title: 'node 3 tootip text',
      },
      {
        id: 4,
        group: 'category',
        label: 'Debit/Credit',
        title: 'node 4 tootip text',
      },
      {
        id: 5,
        group: 'category',
        label: 'Payment Machines',
        title: 'node 5 tootip text',
      },

      {
        id: 6,
        group: 'channel',
        label: 'Channel A',
        title: 'node 2 tootip text',
      },
      {
        id: 7,
        group: 'channel',
        label: 'Channel B',
        title: 'node 2 tootip text',
      },
      {
        id: 8,
        group: 'channel',
        label: 'Channel C',
        title: 'node 2 tootip text',
      },

      {
        id: 9,
        group: 'channel',
        label: 'Channel D',
        title: 'node 2 tootip text',
      },
      {
        id: 10,
        group: 'channel',
        label: 'Channel E',
        title: 'node 2 tootip text',
      },
      {
        id: 11,
        group: 'channel',
        label: 'Channel F',
        title: 'node 2 tootip text',
      },

      {
        id: 12,
        group: 'channel',
        label: 'Channel G',
        title: 'node 2 tootip text',
      },
      {
        id: 13,
        group: 'channel',
        label: 'Channel H',
        title: 'node 2 tootip text',
      },
      {
        id: 14,
        group: 'channel',
        label: 'Channel I',
        title: 'node 2 tootip text',
      },

      {
        id: 15,
        group: 'channel',
        label: 'Channel J',
        title: 'node 2 tootip text',
      },
      {
        id: 16,
        group: 'channel',
        label: 'Channel K',
        title: 'node 2 tootip text',
      },
    ],
    edges: [
      { from: 1, to: 2 },
      { from: 1, to: 3 },
      { from: 1, to: 4 },
      { from: 1, to: 5 },

      { from: 2, to: 6 },
      { from: 2, to: 7 },
      { from: 2, to: 8 },

      { from: 3, to: 9 },
      { from: 3, to: 10 },
      { from: 3, to: 11 },

      { from: 4, to: 12 },
      { from: 4, to: 13 },
      { from: 4, to: 14 },

      { from: 5, to: 15 },
      { from: 5, to: 16 },
    ],
  });
  const options = useGraphOptions();
  const graphRef = React.useRef();
  const events = React.useMemo(
    () => ({
      select: (e) => {
        const data = (graph.nodes || []).find((x) => x.id === e.nodes[0]);
        const children = (graph.edges || [])
          .filter((x) => x.from === e.nodes[0])
          .map(({ to }) => (graph.nodes || []).find((x) => x.id === to));
        onClick({
          data,
          children,
        });
      },
      hoverNode: () => {
        graphRef.current.Network.canvas.body.container.style.cursor = 'pointer';
      },
      blurNode: () => {
        graphRef.current.Network.canvas.body.container.style.cursor = 'default';
      },
    }),
    [onClick, graph]
  );
  return (
    <Graph ref={graphRef} graph={graph} options={options} events={events} />
  );
}

NetworkGraph.defaultProps = {
  onClick: () => {},
};

NetworkGraph.propTypes = {
  onClick: PropTypes.func,
};

export default NetworkGraph;
